import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2d7cf4b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "news-group-container"
};
const _hoisted_2 = {
  class: "pagination-box"
};
import { ref, onMounted } from 'vue';
import { indexMethod } from '@/utils/indexMethod';
import { getWebsiteUserPage } from '@/api/sys.js';
export default {
  __name: 'index',
  setup(__props) {
    const tableData = ref([]);
    const currentPage = ref(1);
    const total = ref(0);
    const pageSize = ref(10);

    /**
     * 获取广告组分页
     */

    // loading效果
    const loading = ref(false);
    const getData = async () => {
      const res = await getWebsiteUserPage({
        currentPage: currentPage.value,
        pageSize: 10
      });
      tableData.value = res.records;
      total.value = res.total;
      currentPage.value = res.current;
    };
    onMounted(() => {
      getData();
    });

    /**
     * 更改当前页码
     * @param {*} val
     */
    const handleCurrentChange = async val => {
      currentPage.value = val;
      await getData();
    };
    return (_ctx, _cache) => {
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _component_el_card = _resolveComponent("el-card");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_card, {
        shadow: "never",
        style: {
          "border": "none"
        }
      }, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: tableData.value,
          style: {
            "width": "100%"
          },
          border: ""
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "序号",
            type: "index",
            index: index => _unref(indexMethod)(index, currentPage.value, pageSize.value),
            align: "center",
            "min-width": 40
          }, null, 8, ["index"]), _createVNode(_component_el_table_column, {
            prop: "name",
            label: "机构名称"
          }), _createVNode(_component_el_table_column, {
            prop: "phone",
            label: "手机号"
          }), _createVNode(_component_el_table_column, {
            prop: "createTime",
            label: "留言时间"
          }), _createVNode(_component_el_table_column, {
            prop: "remark",
            label: "留言"
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createElementVNode("div", _hoisted_2, [_createVNode(_component_el_pagination, {
          class: "pagination",
          onCurrentChange: handleCurrentChange,
          "current-page": currentPage.value,
          "page-size": pageSize.value,
          total: total.value,
          layout: "total,  prev, pager, next, jumper"
        }, null, 8, ["current-page", "page-size", "total"])])]),
        _: 1
      })]);
    };
  }
};